import { render, staticRenderFns } from "./AllAlbums.vue?vue&type=template&id=359ec557&"
import script from "./AllAlbums.vue?vue&type=script&lang=js&"
export * from "./AllAlbums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports